exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo{padding-left:5rem;position:relative;color:#fff;font-family:PT Serif,serif;text-transform:uppercase;letter-spacing:2px}.logo:focus,.logo:hover{text-decoration:none;color:#fff}@media (max-width:767px){.logo{padding-left:3rem}}.logo__brand{display:block;font-size:2rem;line-height:1.1}@media (max-width:1199px){.logo__brand{font-size:1.6rem;line-height:1.4}}@media (max-width:767px){.logo__brand{font-size:1.1rem;line-height:1.3}}.logo__title{font-size:.9rem;opacity:.6}@media (max-width:1199px){.logo__title{font-size:.7rem}}@media (max-width:767px){.logo__title{font-size:.5rem}}.logo__icon{position:absolute;top:0;left:0;z-index:1}@media (max-width:767px){.logo__icon{width:30px;height:30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2f93978","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Logo.vue
// module id = 37
// module chunks = 0